/**
 * IMPORTS
 */

import { ExcluirUsuarioClienteRepositoryImplementation } from "@/data/infra/repositories/usuarios-cliente/excluir-usuario-cliente-repository-impl";
import { ExcluirUsuarioClienteUseCase } from "@/domain/use-cases/usuarios-cliente/excluir-usuario-cliente-use-case";

/**
 * Factory para criar o use case de excluir usuário do cliente.
 */
function makeExcluirUsuarioClienteUseCase() {
  const repository = new ExcluirUsuarioClienteRepositoryImplementation();
  return new ExcluirUsuarioClienteUseCase(repository);
}

/**
 * EXPORT
 */
export { makeExcluirUsuarioClienteUseCase };
